<tam-splitter splitterBarWidth=3 (sizeChange)="sizeChange($event)" [useTransition]="300">
    <tam-splitter-panel [size]="sidelistView.refinedByWidth" [max]="sidelistView.refinedByMax"
        [min]="sidelistView.refinedByMin" [visible]="refineByShow" (collapsedChange)="collapsedChange($event)">
        <ng-container *ngTemplateOutlet="refinedBy"></ng-container>
        <smart-icon tid="refine_by_icon" name="layout-collapse-o" class="collapse light" (click)="collapse()"
            (panstart)="onPanStart()" (panend)="onPanEnd()" (panmove)="onBottonMove($event)"
            [style.display]="refineByShow? 'block' : 'none'">
        </smart-icon>
    </tam-splitter-panel>
    <tam-splitter-panel [size]="sidelistView.previewWidth" [max]="sidelistView.previewMax"
        [min]="sidelistView.previewMin">
        <ng-container *ngTemplateOutlet="preview" class="previewContent"></ng-container>
    </tam-splitter-panel>

</tam-splitter>

<div *ngIf="!disableCollapse">
    <smart-icon name="layout-expand-o" tid="refine_by_icon" class="expand light" (click)="collapse()"
        (panstart)="onPanStart()" (panend)="onPanEnd()" (panmove)="onBottonMoveForExpand($event)"
        [style.display]="refineByShow? 'none' : 'block'"></smart-icon>
</div>